import CONFIG from "../../config";
import { EdelmetallSumme } from "./EdelmetallSumme";
import { SortenSumme } from "./SortenSumme";

export const Summe = CONFIG.getShopConfig({
  edelmetall: EdelmetallSumme,
  sorten: SortenSumme
});
